import React from 'react';
import { PropertyList, Property, PlaceholderProperty } from './styles';
import { ProductCorePropertiesProps } from './types';

export const ProductCoreProperties = ({
  className,
  properties,
  toneDown,
  maxrows,
  size,
  showAsList,
  truncate,
}: ProductCorePropertiesProps) => (
  <PropertyList
    className={className}
    toneDown={toneDown}
    maxRows={maxrows}
    size={size}
    showAsList={showAsList}
  >
    {properties ? (
      properties
        .filter(v => v)
        .map(value => (
          <Property key={value} showAsList={showAsList} truncate={truncate}>
            {value}
          </Property>
        ))
    ) : (
      <PlaceholderProperty toneDown={toneDown} size={size} />
    )}
  </PropertyList>
);

ProductCoreProperties.defaultProps = {
  properties: undefined,
  toneDown: false,
  maxrows: undefined,
  size: 'large',
  showAsList: false,
  className: undefined,
  truncate: false,
};
